import React from 'react';
import { motion } from 'framer-motion';
import { twMerge } from 'tailwind-merge';

const LoadingSpinner = ({ size = 'md', className = '' }) => {
  const sizeClasses = {
    sm: 'w-4 h-4',
    md: 'w-8 h-8',
    lg: 'w-12 h-12',
    xl: 'w-16 h-16'
  };

  return (
    <div className={twMerge('flex items-center justify-center', className)}>
      <motion.div
        animate={{ rotate: 360 }}
        transition={{ duration: 1, repeat: Infinity, ease: "linear" }}
        className={twMerge(
          sizeClasses[size],
          'border-2 border-gray-200 border-t-primary-600 rounded-full'
        )}
      />
    </div>
  );
};

export default LoadingSpinner;